/**
 * Servicio que se encarga del manejo de las peticiones sobre el detalle de las PQR.
 * JMM-2018-07-12
 */
import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { ConfigService } from "../../servicios/config/config.service";
import { KeyService } from "../../servicios/key.service";
import { moment } from "ngx-bootstrap/chronos/test/chain";

@Injectable()
export class TratamientopqrService {
  public tratamientospqr: any[] = [];
  PATH = new ConfigService().obtenerPath();

  constructor(private http: Http, private _key: KeyService) {}

  /**
   * Obtener el listado de registros
   * JMM-2018-07-12
   */
  getDetallePqr() {
    let url = this.PATH + "/api/public/detallepqr";
    return this.http
      .get(url, { headers: this._key.head() })
      .map((resp) => resp.json());
  } // .getDetallePqr()

  /**
   * Obtener un registro por id de un Detalle PQR para editar
   * JMM-2018-07-12
   */
  getRegDetallePqr(id: any) {
    let url = this.PATH + "/api/public/detallepqr/" + id;
    return this.http
      .get(url, { headers: this._key.head() })
      .map((resp) => resp.json());
  } // .getRegDetallePqr(id:any)

  /**
   * Enviar registro del Detalle de la PQR para guardarlo en bd
   * JMM-2018-07-12
   */
  setDetallePqr(detallepqr: any) {
    let url = this.PATH + "/api/public/detallepqr";
    return this.http
      .post(url, detallepqr, { headers: this._key.head() })
      .map((resp) => resp.json());
  } // .setDetallePqr(detallepqr:any)

  /**
   * Editar registro del Detalle de PQR en bd
   * JMM-2018-07-12
   */
  editDetallePqr(detallepqr: any) {
    let url = this.PATH + "/api/public/detallepqr/" + detallepqr.id;
    return this.http
      .put(url, detallepqr, { headers: this._key.head() })
      .map((resp) => resp.json());
  } // .editDetallePqr(detallepqr:any)

  /**
   * Obtener los detalles de una PQR
   * JMM-2018-07-12
   */
  getDetallesPqr(pqrid: any) {
    let url = this.PATH + "/api/public/registrosdetallespqr/" + pqrid;
    return this.http
      .get(url, { headers: this._key.head() })
      .map((resp) => resp.json());
  } // .getDetallesPqr(pqrid:any)

  /**
   * Consultar si la pqr ya fue iniciada en log de tiempo
   * CAAA-2018-11-06
   */
  existePqrLogtiempo(pqrid: any) {
    let url = this.PATH + "/api/existePqrLogtiempo/" + pqrid;
    return this.http
      .get(url, { headers: this._key.head() })
      .map((resp) => resp.json());
  } // .existePqrLogtiempo(pqrid:any)

  /**
   * Enviar registros del tratamiento de la pqr
   * JMM-2019-01-09
   */
  setCreateUpdateTratamientoPqr(tratamientopqr: any) {
    let url = this.PATH + "/api/public/createupdate_tratamientopqr";
    return this.http
      .post(url, tratamientopqr, { headers: this._key.head() })
      .map((resp) => resp.json());
  } // .setCreateUpdateTratamientoPqr(tratamientopqr:any)

  /**
   * Resignar incidencia
   * JMM-2019-01-24
   */
  reasignarCoordinadorIncidencia(datareasignar) {
    let url = this.PATH + "/api/public/reasignarcoordinadorincidencia";
    return this.http
      .post(url, datareasignar, { headers: this._key.head() })
      .map((resp) => resp.json());
  } // .reasignarCoordinadorIncidencia()

  /**
   * Permite confirmar la clave de un coordinador
   * JMM-2019-01-24
   */
  confirmarClaveCoordinador(pqrid: any, coordinadorid: any, clave: any) {
    let url =
      this.PATH +
      "/api/public/confirmarclavecoordinador/" +
      pqrid +
      "/" +
      coordinadorid +
      "/" +
      clave;
    return this.http
      .get(url, { headers: this._key.head() })
      .map((resp) => resp.json());
  } // .reasignarCoordinadorIncidencia()

  /**
   * Permite confirmar la clave de un coordinador desde gendamiento
   * CESAR ARIAS-2019-01-24
   */
  confirmar_clavecoordinadorAgenda(coordinadorid: any, clave: any) {
    let url =
      this.PATH +
      "/api/public/confirmar_clavecoordinadorAgenda/" +
      coordinadorid +
      "/" +
      clave;
    return this.http
      .get(url, { headers: this._key.head() })
      .map((resp) => resp.json());
  } // .confirmar_clavecoordinadorAgenda()

  validarcosto(proveedor: any, anio, pqrid) {
    let url =
      this.PATH +
      "/api/public/validarcosto/" +
      proveedor +
      "/" +
      anio +
      "/" +
      pqrid;
    return this.http
      .get(url, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  validarcostoProveedor(proveedor: any, anio, pqrid) {
    let url =
      this.PATH +
      "/api/public/validarcostoProveedor/" +
      proveedor +
      "/" +
      anio +
      "/" +
      pqrid;
    return this.http
      .get(url, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  /**
   * servisio para requisiciones
   * CESAR ARIAS-2021-04-16
   */
  setHeadpqrInsumos(pqrid: any) {
    let url = this.PATH + "/api/public/setHeadpqrInsumos";
    return this.http
      .post(url, pqrid, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  InsertUpdateInsumo(pqrid: any) {
    let url = this.PATH + "/api/public/InsertUpdateInsumo";
    return this.http
      .post(url, pqrid, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  eliminarRegInsumo(pqrid: any) {
    let url = this.PATH + "/api/public/eliminarRegInsumo";
    return this.http
      .post(url, pqrid, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  setRequisicionCocoraSM(data) {
    let url = this.PATH + "/api/public/setRequisicionCocoraSM";
    return this.http
      .post(url, data, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  setHeadpqrInsumosPqr(data) {
    let url = this.PATH + "/api/public/setHeadpqrInsumosPqr";
    return this.http
      .post(url, data, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  setHeadpqrInsumoPqr(data) {
    let url = this.PATH + "/api/public/setHeadpqrInsumoPqr";
    return this.http
      .post(url, data, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  submitRequisicionIndivi(data) {
    let url = this.PATH + "/api/public/submitRequisicionIndivi";
    return this.http
      .post(url, data, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  submitMultiple(data) {
    let url = this.PATH + "/api/public/submitMultiple";
    return this.http
      .post(url, data, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  submitRelacionarInc(tratamientopqr: any) {
    let url = this.PATH + "/api/public/submitRelacionarInc";
    return this.http
      .post(url, tratamientopqr, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  getIncAsignada(pqrid) {
    let url = this.PATH + "/api/public/getIncAsignada/" + pqrid;
    return this.http
      .get(url, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  eliminarasignacion(id) {
    let url = this.PATH + "/api/public/eliminarasignacion/" + id;
    return this.http
      .get(url, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  fechaLimiteTratamiento(fechapqr, prioridadid) {
    let fechalimite = moment(fechapqr).format("YYYY-MM-DD");
    let horalimite = moment(fechapqr).format("HH:mm:ss");

    let data = {
      prioridadid: prioridadid,
      fecha: fechalimite,
      horainicial: horalimite,
    };
    let url = this.PATH + "/api/public/fechaLimiteTratamiento";
    return this.http
      .post(url, data, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  listaInsumosERPFive(data) {
    let url = this.PATH + "/api/public/insumosPorAlmacendescarga";
    return this.http
      .post(url, data, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  agregarInsumoAPqr(data) {
    let url = this.PATH + "/api/public/agregarInsumoAPqr";
    return this.http
      .post(url, data, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  pedirInsumosRequisicion(data) {
    let url = this.PATH + "/api/public/pedirInsumosRequisicion";
    return this.http
      .post(url, data, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  descargarInsumosRequisicion(data) {
    let url = this.PATH + "/api/public/descargarInsumosRequisicion";
    return this.http
      .post(url, data, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  obtenerInsumosParaRequisicion(data) {
    let url = this.PATH + "/api/public/obtenerInsumosParaRequisicion";
    return this.http
      .post(url, data, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  obtenerFiltrosParaRequisicion() {
    let url = this.PATH + "/api/public/obtenerFiltrosParaRequisicion";
    return this.http
      .get(url, { headers: this._key.head() })
      .map((resp) => resp.json());
  }

  updateEstadoRequisicion(data) {
    let url = this.PATH + "/api/public/updateEstadoRequisicion";
    return this.http
      .post(url, data, { headers: this._key.head() })
      .map((resp) => resp.json());
  }
}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/pqr/tratamientopqr.service.ts